import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './MovuRobotics.frontend.types'

@Injectable({ providedIn: 'root' })
export class MovuRobotics_inbound_services_allocation_shortageService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { order_number?: string, line_number?: string, item_number?: string, requested_ship_quantity?: number, allocation_shortage_quantity?: number, shortage_reasons?: { reason?: string }[] }): Promise<{ result?: $frontendTypes.MovuRobotics.Output, outputDetails?: string[] }> 
  {
    let $url = `${environment.backendUrl}api/allocation-shortage`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

